// Centralised brand content + classy Unsplash food imagery for each service.
// Image URLs use Unsplash CDN with sensible width/quality params.

const u = (id, w = 1400) =>
    `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=85`;

export const HERO_IMAGE = u("photo-1555244162-803834f70033", 1800);

export const SERVICES = [
    {
        slug: "corporate-meal",
        name: "Corporate Meal Services",
        short: "Breakfast, lunch & dinner that fuel productivity.",
        long: "Elevate workplace satisfaction with our breakfast, lunch, and dinner options that not only fuel productivity but also delight your employees' discerning taste buds.",
        image: "/brochure/corporate_meal.png",
        kind: "Daily Programme",
    },
    {
        slug: "hospital-meal",
        name: "Hospital Meal Services",
        short: "Nourishment crafted for the healing journey.",
        long: "We play a vital role in the healing process by delivering nourishing meals customized to meet the dietary needs of patients, ensuring a holistic approach to recovery.",
        image: "/brochure/hospital_meal.jpg",
        kind: "Healthcare",
    },
    {
        slug: "senior-citizen",
        name: "Senior Citizen Meal Services",
        short: "Balanced, delightful dining for healthy aging.",
        long: "Specially crafted meals designed to support healthy aging, providing balanced and delightful dining experiences tailored to the preferences of seniors.",
        image: "/brochure/senior_meal.png",
        kind: "Care Programme",
    },
    {
        slug: "hostel-meal",
        name: "Hostel Meal Service",
        short: "Wholesome meals that fuel academic journeys.",
        long: "We keep students well-fed with a variety of wholesome meals that fuel their academic journey and promote overall well-being.",
        image: "/brochure/hostel_meal.png",
        kind: "Residential",
    },
    {
        slug: "canteen-management",
        name: "Educational Canteen Management",
        short: "Quality, hygiene & an ever-evolving menu.",
        long: "Our canteen management services focus on quality, hygiene, and an ever-evolving menu to cater to the unique needs of educational institutions.",
        image: "/brochure/canteen_mgmt.png",
        kind: "Operations",
    },
    {
        slug: "social-event-catering",
        name: "Social Event Catering",
        short: "Culinary magic for unforgettable gatherings.",
        long: "We create culinary magic for your social gatherings, making every event memorable with our delightful dishes.",
        image: "/brochure/social_event.png",
        kind: "Events",
    },
    {
        slug: "corporate-event-catering",
        name: "Corporate Event Catering",
        short: "Professionalism paired with delectable cuisine.",
        long: "Elevate your corporate events with our exquisite catering services, offering a blend of professionalism and delectable cuisine.",
        image: "/brochure/corporate_event.png", // elegant corporate dinner setting
        kind: "Events",
    },
    {
        slug: "party-orders",
        name: "Personalized Party Orders",
        short: "Tailored celebrations on a per-plate basis.",
        long: "Tailor your special events with our personalized party orders, adding a unique touch to your celebrations — pricing on a per-plate basis.",
        image: "/brochure/party_orders.png", // lavish per-plate gourmet spread
        kind: "Per-Plate",
    },
];

export const SERVICE_NAMES = SERVICES.map((s) => s.name).concat(["Other"]);

export const CLIENTS = [
    { name: "Flipkart", logo: "/brochure/clients/flipkart.jpg" },
    { name: "Myntra", logo: "/brochure/clients/myntra.jpg" },
    { name: "IDBI Bank", logo: "/brochure/clients/idbi.png" },
    { name: "JK University", logo: "/brochure/clients/jk_university.png" },
    { name: "JKSI", logo: "/brochure/clients/jksi.png" },
    { name: "JKYOG Trust", logo: "/brochure/clients/jkyog.jpg" },
    { name: "OASME", logo: "/brochure/clients/oasme.png" },
    { name: "Combad Adventure Training & Security Services", logo: "/brochure/clients/combad.jpeg" },
    { name: "Rarean Fluid Tech", logo: "/brochure/clients/rarean.jpg" },
    { name: "Innovize Thermal Solutions", logo: "/brochure/clients/innovize.png" },
    { name: "ARCOS", logo: "/brochure/clients/arcos.png" },
    { name: "Extencore", logo: "/brochure/clients/extencore.jpg" },
];

export const CONTACT = {
    phone: "+91 82496 80443",
    email: "care@thefoodgala.com",
    address: "Shankarpur, Diha Sahi, Arunodaya Market, Cuttack 753012",
};

export const CERTIFICATIONS = [
    {
        name: "FSSAI",
        full: "Food Safety & Standards Authority of India",
        image: "/brochure/certs/fssai.jpg",
    },
    {
        name: "ISO 9001:2015",
        full: "Quality Management System",
        image: "/brochure/certs/iso.png",
    },
    {
        name: "Zed Silver Certified",
        full: "MSME · Zero Defect Zero Effect",
        image: "/brochure/certs/zed.jpg",
    },
];

export const WHY_US = [
    {
        title: "Personalized Perfection",
        body: "We understand unique preferences and dietary needs of each individual, crafting tailor-made meal solutions for your distinctive palate.",
    },
    {
        title: "Diverse Delights",
        body: "An extensive menu guaranteeing even the most discerning taste buds will be delighted — a rich tapestry of flavours to explore.",
    },
    {
        title: "Nourishing Health",
        body: "Prioritising nutrition and well-being — special diet options, balanced meals and portion control for diverse dietary requirements.",
    },
    {
        title: "Professional Expertise",
        body: "Culinary artisans preparing meals with the freshest, finest ingredients — an extraordinary dining experience, every plate.",
    },
    {
        title: "Timely Delivery",
        body: "We respect the value of your time — punctual deliveries are a testament to our commitment to honouring your schedule.",
    },
];
